import { render } from "./windowAddForm.vue?vue&type=template&id=51f30ebb"
import script from "./windowAddForm.vue?vue&type=script&lang=js"
export * from "./windowAddForm.vue?vue&type=script&lang=js"

import "./windowAddForm.vue?vue&type=style&index=0&id=51f30ebb&lang=css"
script.render = render

export default script